import { api } from '@/adapter'

const fetchStocksMoveTaskDetails = async (query: any): Promise <any>  => {
  return api({
    url: "getStockMoveTask", 
    method: "get",
    params: query,
    cache: true
  });
}

const completeStockMoveTask = async (data: any): Promise <any>  => {
  return api({
    url: "/service/completeStockMoveTask", 
    method: "post",
    data: data
  });
}

const fetchTasksList = async(data: any): Promise<any> => {
  return api({
    url: "performFind", 
    method: "post",
    data
  });
}

const assignReplenisher = async(data: any): Promise<any> => {
  return api({
    url: "service/assignReplenisherToStockMoveTasks", 
    method: "post",
    data
  });
}

export const StockService = {
  assignReplenisher,
  fetchStocksMoveTaskDetails,
  fetchTasksList,
  completeStockMoveTask
}